import { RouteObject } from "react-router-dom";
import ProtectedRoute from "../Routes/ProtectedRoute";
import { PredefinedWord } from "../Routes/Predefined";
import { ROUTES } from "../Routes/routes";
import DentistLayout from "../layouts/DentistLayout";
import Dashboard from "../components/DentistHub/Dashboard";
import ClinicDetails from "../components/DentistHub/ClinicDetails";
import DentistProfile from "../components/DentistHub/DentistProfile";
import DraftList from "../components/DentistHub/Drafts/DraftList";
import Settings from "../components/DentistHub/Settings";
import DentistReport from "../components/DentistHub/DentistReport";
import CompleteOrder from "../components/DentistHub/CompleteOrder";
import DentistCancelOrder from "../components/DentistHub/DentistCancelOrder";
import ChangePassword from "../layouts/ChangePassword";
import RaiseTicket from "../components/DentistHub/RaiseTicket";
import ContactSupport from "../components/DentistHub/ContactSupport";
import DentistContactSupport from "../components/DentistHub/DentistContactSupport";
import PaymentRetryPage from "../components/DentistHub/PaymentRetryPage";
import ScheduledOrders from "../components/DentistHub/ScheduledOrders";
import ScheduleOrdersList from "../components/DentistHub/ScheduleOrdersList";
export const dentistRoutes: RouteObject[] = [
  {
    element: (
      <ProtectedRoute allowedRoles={[PredefinedWord.Roles.DENTIST]} />
    ),
    children: [
      {
        element: <DentistLayout />,
        children: [
          {
            path: ROUTES.DENTIST.DENTIST_DASHBOARD,
            element: <Dashboard />,
          },
          {
            path: ROUTES.DENTIST.DENTIST_DASHBOARD + "/:draftId",
            element: <Dashboard />,
          },
          {
            path: ROUTES.DENTIST.CLINIC_DETAILS,
            element: <ClinicDetails />,
          },
          {
            path: ROUTES.DENTIST.DENTIST_PROFILE,
            element: <DentistProfile />,
          },
          {
            path: ROUTES.DENTIST.DENTIST_DRAFT_LIST,
            element: <DraftList />,
          },
          {
            path: ROUTES.DENTIST.DENTIST_SETTINGS,
            element: <Settings />,
          },
          {
            path: ROUTES.DENTIST.DENTIST_CancelOrder,
            element: <DentistCancelOrder />,
          },
          {
            path: ROUTES.DENTIST.CompleteOrder,
            element: <CompleteOrder />,
          },
          {
            path: ROUTES.DENTIST.ChangePassword,
            element: <ChangePassword />,
          },
          {
            path: ROUTES.DENTIST.DENTIST_Report,
            element: <DentistReport />,
          },
          {
            path: ROUTES.DENTIST.RaiseTicket,
            element: <RaiseTicket />,
          },
           {
            path:ROUTES.DENTIST.ContactSupport,
            element: <ContactSupport />,
          },
           {
            path:ROUTES.DENTIST.DentistContactSupport,
            element: <DentistContactSupport />,
          },
          {
            path:ROUTES.DENTIST.PaymentRetryPage,
            element: <PaymentRetryPage />,
          },
           {
            path:ROUTES.DENTIST.PaymentRetryPage,
            element: <PaymentRetryPage />,
          },
          {
            path: ROUTES.DENTIST.ScheduledOrders,
            element: <ScheduledOrders />,
          },
          {
            path: ROUTES.DENTIST.ScheduleOrdersList,
            element: <ScheduleOrdersList />,
          },
        ],
      },
    ],
  },
];